<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('item.stockSet')" center width="700px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">

        <div class="mydialog df-l-c-fs">
          <div class="text f-l">{{$t('item.stockSetDesc')}}</div>
          <InputCustom
            :inputable="true"
            inputWidth="620"
            :inputValue="count" />
          <div class="box df-c-ct">
            <Keyboard :inputValue.sync="count" />
          </div>
        </div>
          
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="whitebtn" @click="clearLeftCount">{{$t('item.stockSetClear')}}</div>
        <div class="themebtn" @click="sendLeftCount">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogStock',
  data() {
    return {
      isShowDialog: false,

      item: {},
      count: '0',
    }
  },
  methods: {
    open(item) {
      this.item = item
      this.count = String(item.leftCountShow)
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.itemId = {}
      this.count = '0'
    },

    async sendLeftCount() {
      const _D = await this.setData('item', {
        id: this.item.itemId || this.item.id,
        leftCount: this.count,
      })
      if (_D) {
        this.item.leftCountShow = Number(this.count)
        this.close()
      }
    },
    clearLeftCount() {
      this.$api.leftCount_clear({
        id: this.item.itemId || this.item.id
      }).then(res => {
        if (res.status == 0) {
          this.item.leftCountShow = ''
          this.close()
        } else { this._status(res) }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px 40px 0;
  .text{line-height: 40px;}
  .box{margin-top: 20px;}
}
</style>